import { render } from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=template&id=5f3a6c06&scoped=true"
import script from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"

import "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=style&index=0&id=5f3a6c06&scoped=true&lang=less"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3a6c06"]])

export default __exports__